import React from "react";
import { ChordContainer } from "../../model/containers";
import {
    Chord,
    NoteDuration,
    TimeSignature
} from "../../model/core";
import { useZoomFactor } from "../../stores/ZoomStore";
import { ChordInputFloatingDialog } from "../dialogs/ChordInputFloatingDialog";
import {
    getLeftNearestGridPoint,
    NOTE_WIDTH
} from "../../render/renderUtils";
import { GridResolution } from "../../model/grid";
import './ChordRollInputLayer.css';


function noteDurationToPixelWidth(
    duration: NoteDuration,
    ppq: number,
    zoomFactor: number
) {
    return (duration.value * ppq) / zoomFactor;
}

export function ChordRollInputLayerCollpased({
    hnc,
    newNoteDuration,
    updateChordRollCB,
    gridResolution,
    timeSignature
}: {
    hnc: ChordContainer,
    newNoteDuration: NoteDuration,
    updateChordRollCB: (start: number, chord: Chord) => void,
    gridResolution: GridResolution,
    timeSignature: TimeSignature
}) {
    const inputButtonRef = React.useRef<HTMLDivElement>(null);
    const [chordSelectorRefEl, setChordSelectorRefEl] = React.useState<EventTarget & HTMLElement>();
    const [startPosition, setStartPosition] = React.useState<number>();
    const zoomFactor = useZoomFactor();
    let currentPosition: number = 0;

    const showInput = () => {
        if (!startPosition && startPosition !== 0) return;
        if (inputButtonRef.current) {
            inputButtonRef.current.style.display = 'block';
        }
    }
    const hideInput = () => {
        if (!startPosition && startPosition !== 0) return;
        if (inputButtonRef.current) {
            inputButtonRef.current.style.display = 'none';
        }
    }

    return (<>
        <div className={"chord-roll-input-layer--collapsed"}
            onMouseEnter={showInput}
            onMouseLeave={hideInput}
            onMouseMove={(e) => {
                if (chordSelectorRefEl) return; // if the dialog is open, don't move the input button.
                if (inputButtonRef.current) {
                    // center the input button on the mouse position
                    const rawPos = Math.max(
                        0,
                        0 | e.clientX - e.currentTarget.getBoundingClientRect().left - (noteDurationToPixelWidth(newNoteDuration, hnc.getPPQ(), zoomFactor) / 2)
                    );
                    const pos = getLeftNearestGridPoint(
                        rawPos * zoomFactor / NOTE_WIDTH,
                        hnc.getPPQ(),
                        zoomFactor,
                        gridResolution,
                        timeSignature
                    ) * NOTE_WIDTH / zoomFactor;

                    currentPosition = pos;
                    inputButtonRef.current.style.left = `${pos}px`;
                }
            }}
        >
            <div className={"chord-roll-input-layer--input-button"}
                style={{
                    width: `${noteDurationToPixelWidth(newNoteDuration, hnc.getPPQ(), zoomFactor)}px`,
                }}
                ref={inputButtonRef}>
                <div className={"chord-input--empty"}
                    onClick={(e) => {
                        const commitedPosition = 0 | currentPosition * zoomFactor / NOTE_WIDTH;
                        setChordSelectorRefEl(e.currentTarget);
                        setStartPosition(commitedPosition);
                    }} />
            </div>
        </div>
        {chordSelectorRefEl &&
            <ChordInputFloatingDialog
                chordSelectorRefEl={chordSelectorRefEl}
                updateChordCB={(chord) => {
                    if (!chord) return;
                    // FIXME: fuck javascript type coertion.
                    if (!startPosition && startPosition !== 0) return;
                    updateChordRollCB(startPosition, chord)
                }}
                setChordSelectorRefEl={setChordSelectorRefEl} />
        }
    </>);
}